export default __webpack_public_path__ + "static/media/icon_timer_play.33c7018c.svg";